module.exports = __webpack_public_path__ + "img/2_222.57f8c108.png";